import React from 'react'
import { StyledDateForm, Props } from './styled'

export const DateForm: React.FC<Props> = (props: Props) => {
  return <StyledDateForm {...props} />
}
